import React from "react";
import { Link } from "react-router-dom";
import { Star } from "@phosphor-icons/react";

const STAGE_STYLES = {
  "Plenary": "bg-[#000000] text-[#FFFFFF]",
  "Concurrent 1": "bg-[#E5E9F0] text-[#1c1c24]",
  "Concurrent 2": "bg-[#E5E9F0] text-[#1c1c24]",
  "Concurrent 3": "bg-[#E5E9F0] text-[#1c1c24]",
};

export default function SessionCard({ session, isFavorite, onToggleFavorite, showTrack = false, hideTime = false }) {
  const accent = session.stage === "Plenary";
  const isBreak = (session.track || "").toLowerCase() === "break";
  return (
    <Link
      to={`/program/${session.id}`}
      data-testid={`session-card-${session.id}`}
      className={`group block relative p-4 sm:p-5 bg-[#FFFFFF] border border-[#E5E9F0] rounded-sm transition-all duration-200 hover:-translate-y-[1px] hover:border-[#000000] ${
        isFavorite ? "border-l-4 border-l-[#000000]" : ""
      } ${isBreak ? "opacity-70" : ""}`}
    >
      <div className="flex items-start gap-3">
        {!hideTime && (
          <div className="flex-shrink-0 w-16">
            <div className="font-mono-time text-sm text-[#000000]" data-testid={`session-time-${session.id}`}>
              {session.start_time}
            </div>
            <div className="font-mono-time text-[10px] text-[#7A828C]">{session.end_time}</div>
          </div>
        )}

        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 flex-wrap mb-1.5">
            <span className={`text-[10px] font-mono-time uppercase tracking-wider px-1.5 py-0.5 rounded-sm ${STAGE_STYLES[session.stage] || "bg-[#E5E9F0]"}`}>
              {session.stage_label || session.stage}
            </span>
            {showTrack && session.track && !isBreak && (
              <span className="text-[10px] font-mono-time uppercase tracking-wider text-[#7A828C]">{session.track}</span>
            )}
          </div>
          <h3 className="font-display text-[17px] leading-tight mb-1.5 group-hover:text-[#000000] transition-colors">
            {session.title}
          </h3>
          {(session.speakers || []).length > 0 && (
            <p className="text-sm text-[#5a5a5a] line-clamp-1">
              {(session.speakers || []).map((s) => s.name).join(" · ")}
            </p>
          )}
        </div>

        {!isBreak && onToggleFavorite && (
          <button
            onClick={(e) => { e.preventDefault(); e.stopPropagation(); onToggleFavorite(session.id); }}
            data-testid={`session-favorite-${session.id}`}
            aria-label={isFavorite ? "Remove from My Agenda" : "Add to My Agenda"}
            className="flex-shrink-0 w-11 h-11 -mr-2 grid place-items-center rounded-sm hover:bg-[#F0F2F7] transition-colors"
          >
            <Star size={20} weight={isFavorite ? "fill" : "regular"} className={isFavorite ? "text-[#000000]" : "text-[#7A828C]"} />
          </button>
        )}
      </div>
    </Link>
  );
}
